import { Component, defineComponent } from '@decify/cell-shopify/client';
import { sliderName, sliderSlideChangeEvent } from '../Slider';
import './ProductMediaGallery.scss';
export const productMediaGalleryName = 'ProductMediaGallery';
export const productMediaGalleryTagName = 'cell-component-product-media-gallery';
export class ProductMediaGallery extends Component {
    elements;
    constructor() {
        super(productMediaGalleryName);
        // TODO: Validate that expected chlildren are present.
        this.elements = {
            playVideoButton: this.querySelector('.ProductMediaGallery__PlayVideoButton'),
        };
        this.handleSlideChange = this.handleSlideChange.bind(this);
    }
    componentDidMount() {
        this.subscribe(`${sliderName}.${sliderSlideChangeEvent}`, this.handleSlideChange);
    }
    handleSlideChange(data) {
        if (this.elements.playVideoButton) {
            // Show the play video button only on the first slide.
            this.elements.playVideoButton.classList.toggle('Hidden', data.activeIndex !== 0);
        }
    }
}
defineComponent(productMediaGalleryTagName, ProductMediaGallery);
